import React from "react";
import db from "../../../services/query";
import { allReportPages } from "../../common/ParityReport";
import AriaReport, { buildPrintDocumentTitle, faDigits, usePrintData } from "./AriaReport";

export default function ApplicantsPrint({ location }) {
  const query = new URLSearchParams(location.search);
  const entryYearId = query.get("entryYearId") || "";
  const facultyId = query.get("facultyId") || "";
  const search = query.get("search") || "";
  const { loading, error, data } = usePrintData(
    async () => {
      const params = new URLSearchParams({
        orderBy: "student_id",
        order: "desc",
      });
      if (entryYearId) params.set("entryYearId", entryYearId);
      if (facultyId) params.set("facultyId", facultyId);
      if (search) params.set("search", search);
      const rows = await allReportPages(`students/applicants?${params}`);
      return { data: rows };
    },
    [entryYearId, facultyId, search]
  );
  const rows = Array.isArray(data) ? data : [];

  if (loading) return <p className="aria-report-status">در حال آماده‌سازی گزارش…</p>;
  if (error) return <p className="aria-report-status" role="alert">{error}</p>;

  return (
    <AriaReport
      className="applicants-report"
      landscape
      pageMargin="10mm"
      documentTitle={buildPrintDocumentTitle(["لیست متقاضیان", faDigits(rows[0]?.entry_year || entryYearId)])}
      rightLines={["لیست داوطلبان", faDigits(rows[0]?.entry_year || "")]}
      leftLines={["وزارت تحصیلات عالی", "پوهنتون آریا", "معاونیت علمی"]}
    >
      <table className="aria-report-table applicants-table">
        <thead>
          <tr>
            {[
              "شماره",
              "کد دانشجو",
              "کد ملی",
              "نام",
              "نام پدر",
              "نام پدر کلان",
              "ولایت اصلی",
              "ولایت فعلی",
              "شماره تماس",
              "شماره تذکره",
              "لیسه",
              "سال فراغت",
              "سال شمولیت",
              "فاکولته",
              "دیپارتمنت",
              "نمره کانکور ملی",
              "نمره کانکور آریا",
              "ثبت نام",
            ].map((label) => (
              <th key={label}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={18} className="aria-report-empty">داوطلبی برای نمایش یافت نشد.</td>
            </tr>
          ) : rows.map((row, index) => (
            <tr key={row.student_id || index}>
              <td>{faDigits(index + 1)}</td>
              <td className="nowrap">{row.aria_id}</td>
              <td className="nowrap">{row.nexa_id}</td>
              <td className="name-col">{row.student_name}</td>
              <td className="name-col">{row.student_father_name}</td>
              <td className="name-col">{row.grand_father_name}</td>
              <td>{row.permanent_city}</td>
              <td>{row.current_city}</td>
              <td className="nowrap" dir="ltr">{row.student_phone}</td>
              <td className="nowrap">{row.tazkera_no}</td>
              <td>{row.school_name}</td>
              <td className="nowrap">{faDigits(row.graduation_year || "")}</td>
              <td className="nowrap">{faDigits(row.entry_year || "")}</td>
              <td>{row.faculty}</td>
              <td>{row.department}</td>
              <td className="nowrap">{faDigits(row.gov_kankor_score ?? "")}</td>
              <td className="nowrap">{faDigits(row.aria_kankor_score ?? "")}</td>
              <td className={Number(row.registration_complete) === 1 ? "" : "is-incomplete"}>
                {Number(row.registration_complete) === 1 ? "تکمیل" : "ناتکمیل"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AriaReport>
  );
}
